import { useEffect, useState } from "react";
import { userService } from "../../services/userService";
import { UserDto, userFields } from "../../types/user";

export const UserList = () => {
  const [users, setUsers] = useState<UserDto[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    const fetchUsers = async () => {
      try {
        setLoading(true);
        const data = await userService.getAll({}, controller.signal);
        setUsers(data);
      } catch (err: any) {
        if (err.name !== "CanceledError") {
          setError("Αποτυχία φόρτωσης χρηστών");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();

    return () => controller.abort();
  }, []);

  if (loading) return <div>Φόρτωση...</div>;
  if (error) return <div>Σφάλμα: {error}</div>;

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="border-b bg-gray-50">
            {userFields.map((field) => (
              <th key={field.name} className="p-3 font-semibold text-gray-700">
                {field.label}
              </th>
            ))}
            <th className="p-3 font-semibold text-gray-700">Ενέργειες</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user: UserDto) => (
            <tr key={user.userId} className="border-b hover:bg-gray-50">
              {userFields.map((field) => (
                <td key={field.name} className="p-3">
                  {(field.type as string) === "checkbox"
                    ? user[field.name as keyof UserDto]
                      ? "✅"
                      : "❌"
                    : String(user[field.name as keyof UserDto] ?? "")}
                </td>
              ))}
              <td className="p-3">
                <button className="text-primary hover:text-darkprimary font-medium">
                  Επεξεργασία
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
